import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withTooltip } from '@/utils';
import { ClockIcon } from '../icons';
export var TimeAvailability = function (_a) {
    var availability = _a.availability;
    if (!(availability === null || availability === void 0 ? void 0 : availability.length))
        return null;
    return (_jsxs("div", { className: 'flex items-baseline gap-1', children: [withTooltip('Availability', true, _jsx(ClockIcon, {})), _jsx("span", { children: availability.map(function (item, key) { return (_jsxs("span", { children: [item === 'is_full_time' && 'Full Time', item === 'is_part_time' && 'Part Time', availability.length - 1 === key ? '' : _jsx("i", { children: "," })] }, key)); }) })] }));
};
